import grpcClient from '~/grpc/grpc-client'
import { commonMetaData } from '@/store/_helpers/common-helper'

// initial state
const initialState = () => ({
  id: null,
  profileId: null,
  description: null,
  priceGroupsList: []
})

// state
export const state = () => initialState()

// getters
export const getters = {
  registeredMasterCategoryIds: state => {
    return state.priceGroupsList.map(p => p.masterCategoryId)
  }
}

const sort = price => {
  if (!price || price.priceGroupsList.length === 0) return price

  price.priceGroupsList.sort((a, b) => {
    if (a.position < b.position) {
      return -1
    } else if (a.position > b.position) {
      return 1
    } else {
      return 0
    }
  })

  return price
}

// actions
export const actions = {
  async fetchMyPrice({ commit, rootState }) {
    const [{ GetMyPricesRequest }, { PriceService }] = await Promise.all([
      import('~/stub/apigateway/profile/price_pb'),
      import('~/stub/apigateway/profile/price_pb_service')
    ])

    const metadata = commonMetaData(rootState)
    const request = new GetMyPricesRequest()
    const response = await grpcClient({
      method: PriceService.GetMyPrices,
      request,
      metadata
    })
    response.price = sort(response.price)
    commit('RECEIVE_PRICE', response)
  },
  async updatePrice({ dispatch, rootState }, { description }) {
    const [{ UpdatePriceRequest }, { PriceService }] = await Promise.all([
      import('~/stub/apigateway/profile/price_pb'),
      import('~/stub/apigateway/profile/price_pb_service')
    ])

    const metadata = commonMetaData(rootState)
    const request = new UpdatePriceRequest()
    request.setDescription(description)
    await grpcClient({
      method: PriceService.UpdatePrice,
      request,
      metadata
    })
    await dispatch('fetchMyPrice')
  },
  async createPriceGroup({ dispatch, rootState }, { masterCategoryId, position, priceItems }) {
    const [{ UpdatePriceGroupRequest }, { PriceService }, { PriceItemRequest }] = await Promise.all(
      [
        import('~/stub/apigateway/profile/price_pb'),
        import('~/stub/apigateway/profile/price_pb_service'),
        import('~/stub/profileservice/price_pb')
      ]
    )

    const metadata = commonMetaData(rootState)

    const priceItemsList = priceItems.map(item => {
      const priceItemRequest = new PriceItemRequest()
      priceItemRequest.setTitle(item.title)
      priceItemRequest.setDaysToDelivery(item.daysToDelivery)
      priceItemRequest.setMinimumPrice(item.minimumPrice)
      priceItemRequest.setNote(item.note)
      return priceItemRequest
    })

    const request = new UpdatePriceGroupRequest()
    request.setMasterCategoryId(masterCategoryId)
    request.setPosition(position)
    request.setPriceItemsList(priceItemsList)

    await grpcClient({
      method: PriceService.UpdatePriceGroup,
      request,
      metadata
    })
    await dispatch('fetchMyPrice')
  },
  async updatePriceGroup({ dispatch, rootState }, { id, masterCategoryId, position, priceItems }) {
    const [{ UpdatePriceGroupRequest }, { PriceService }, { PriceItemRequest }] = await Promise.all(
      [
        import('~/stub/apigateway/profile/price_pb'),
        import('~/stub/apigateway/profile/price_pb_service'),
        import('~/stub/profileservice/price_pb')
      ]
    )

    const metadata = commonMetaData(rootState)

    const priceItemsList = priceItems.map(item => {
      const priceItemRequest = new PriceItemRequest()
      priceItemRequest.setTitle(item.title)
      priceItemRequest.setDaysToDelivery(item.daysToDelivery)
      priceItemRequest.setMinimumPrice(item.minimumPrice)
      priceItemRequest.setNote(item.note)
      return priceItemRequest
    })

    const request = new UpdatePriceGroupRequest()
    request.setId(id)
    request.setMasterCategoryId(masterCategoryId)
    request.setPosition(position)
    request.setPriceItemsList(priceItemsList)

    await grpcClient({
      method: PriceService.UpdatePriceGroup,
      request,
      metadata
    })
    await dispatch('fetchMyPrice')
  },
  async deletePriceGroup({ dispatch, rootState }, { id }) {
    const [{ DeletePriceGroupRequest }, { PriceService }] = await Promise.all([
      import('~/stub/apigateway/profile/price_pb'),
      import('~/stub/apigateway/profile/price_pb_service')
    ])

    const metadata = commonMetaData(rootState)
    const request = new DeletePriceGroupRequest()
    request.setId(id)
    await grpcClient({
      method: PriceService.DeletePriceGroup,
      request,
      metadata
    })
    await dispatch('fetchMyPrice')
  }
}

// mutations
export const mutations = {
  RECEIVE_PRICE(state, data) {
    Object.assign(state, data.price)
  }
}
